import { SvgIcon, type SvgIconProps } from '@mui/material';

/**
 * Moon / sun glyphs for the navbar light–dark toggle. The Capital icon set
 * ships no weather icons, so these use the same Material Design Icons paths
 * Capital is built on. Color/size inherit from the SvgIcon (theme-driven).
 */
export function MoonIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M17.75 4.09l-2.53 1.94.91 3.06-2.63-1.81-2.63 1.81.91-3.06-2.53-1.94 3.19-.09L13.5 1l1.06 3 3.19.09m3.5 6.91l-1.64 1.25.59 1.98-1.7-1.17-1.7 1.17.59-1.98L15.75 11l2.06-.05.69-1.95.69 1.95 2.06.05m-2.28 4.95c.83-.08 1.72 1.1 1.19 1.85-.32.45-.66.87-1.08 1.27-3.91 3.93-10.24 3.93-14.14 0-3.91-3.9-3.91-10.24 0-14.14.4-.4.82-.76 1.27-1.08.75-.53 1.93.36 1.85 1.19-.27 2.86.69 5.83 2.89 8.02 2.19 2.2 5.15 3.16 8.02 2.89z" />
    </SvgIcon>
  );
}

export function SunIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M3.55 18.54l1.41 1.41 1.8-1.79-1.42-1.42-1.79 1.8M11 22.45h2V19.5h-2v2.95M12 5.5A6.5 6.5 0 0 0 5.5 12 6.5 6.5 0 0 0 12 18.5 6.5 6.5 0 0 0 18.5 12 6.5 6.5 0 0 0 12 5.5m8 7.5h3v-2h-3v2m-2.76 5.66l1.8 1.79 1.41-1.41-1.79-1.8-1.42 1.42m1.42-13.7l-1.41-1.41-1.8 1.79 1.42 1.42 1.79-1.8M13 .55h-2V3.5h2V.55M4 13v-2H1v2h3m2.76-8.16L4.96 3.05 3.55 4.46l1.79 1.8 1.42-1.42z" />
    </SvgIcon>
  );
}

export function GlobeIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
    </SvgIcon>
  );
}
